import { DismissIcon } from "../../../materials/icons/dismiss-icon/DismissIcon";
import { Heading } from "../../heading/Heading";
import { IconButton } from "../../icon-button/IconButton.Parts";
import { Actions, PanelHeaderRow, Props } from "./PanelHead.Parts";

export const PanelHead = ({ title, onClose, actions, className }: Props) => {
  return (
    <PanelHeaderRow className={className}>
      <Heading variant="h4">{title}</Heading>
      <Actions>
        {actions}
        <IconButton onClick={onClose}>
          <DismissIcon />
        </IconButton>
      </Actions>
    </PanelHeaderRow>
  );
};
